import type { CustomIconProps } from '../CustomIcon';

export const PushDeclinedIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='m23 2-7 20-4-9-9-4 20-7Z' fill='#BDDEE1' />
      <path
        d='M23 2 12 13'
        stroke='#006D86'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx={7} cy={17} r={6} fill='#D8601E' stroke='#fff' />
      <path stroke='#fff' strokeWidth={1.5} d='m4.53 14.47 5 5M9.47 14.47l-5 5' />
    </svg>
  );
};
